import LinkIcon from '@mui/icons-material/Link';
import TwitterIcon from '@mui/icons-material/Twitter';
import {
  Box, Button, createSvgIcon, Link, Typography, useTheme,
} from '@mui/material';
import { Token } from '@uniswap/sdk-core';
import { CommonModal, TokenAvatarPair } from 'common-client';
import React from 'react';
import { ReactComponent as DiscordIcon } from '../assets/icons/DiscordIcon.svg';

export interface AuctionCreatedModalProps {
  /**
   * The left token
   */
  leftToken?: Token | null;
  /**
   * The right token
   */
  rightToken?: Token | null;
  /**
   * Callback for redirecting to the auction
   */
  onGoToAuction?: () => void;
  /**
   * Callback when closing the modal
   */
  onClose?: () => void;
  /**
   * Link to 3rd party block explorer
   */
  transactionLink?: string;
  /**
   * The text associated with the transaction
   */
  transactionText?: string;
  /**
   * Whether the modal is open
   */
  open: boolean;
  /**
   * Message to show in escape hatch
   */
  escapeHatchMessage?: string | null;
}

export function AuctionCreatedModal({
  leftToken,
  rightToken,
  onGoToAuction,
  onClose,
  transactionLink,
  transactionText,
  open,
  escapeHatchMessage,
}: AuctionCreatedModalProps) {
  const theme = useTheme();
  const GeneratedDiscordIcon = createSvgIcon(<DiscordIcon />, 'DiscordIcon');

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      escapeHatchMessage={escapeHatchMessage}
      testId="auction-created-modal"
    >
      <Box
        height="48px"
        display="flex"
        justifyContent="center"
      >
        <TokenAvatarPair
          leftToken={leftToken || null}
          rightToken={rightToken || null}
        />
      </Box>
      <Typography
        align="center"
        fontSize="24px"
        fontWeight={700}
        fontFamily={theme.typography.fontFamily}
        my="8px"
      >
        Auction has been Created
      </Typography>
      {
        transactionText && (
          <Typography
            align="center"
            color={theme.palette.logo}
            fontSize="16px"
            fontWeight={400}
          >
            {transactionText}
          </Typography>
        )
      }
      <Typography
        align="center"
        fontSize="16px"
        fontWeight={700}
        my="16px"
      >
        Share Auction
      </Typography>
      <Box display="flex" justifyContent="center">
        <Link
          color={theme.palette.logo}
          href="https://twitter.com/ButtonDeFi"
          target="_blank"
        >
          <TwitterIcon />
        </Link>
        <Link
          color={theme.palette.logo}
          href="https://discord.gg/ApK5HRZBQU"
          target="_blank"
          style={{ margin: '0 40px' }}
        >
          <GeneratedDiscordIcon />
        </Link>
        <Link
          color={theme.palette.logo}
          href={transactionLink}
          target="_blank"
        >
          <LinkIcon />
        </Link>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        {onGoToAuction && (
          <Button
            onClick={onGoToAuction}
            variant="contained"
            style={{
              borderRadius: '24px', width: '100%', fontSize: '14px', margin: '40px 0 28px', padding: '12px',
            }}
          >
            Go to Auction
          </Button>
        )}
        <Button
          onClick={onClose}
          style={{
            borderRadius: '24px', width: '100%', fontSize: '14px', padding: '12px',
          }}
        >
          Done
        </Button>
      </Box>
    </CommonModal>
  );
}
